import { HugeiconsIcon, IconSvgElement } from '@hugeicons/react';
import { Button, ButtonProps, Stack, Typography, useTheme } from '@mui/material';

interface Props {
  title?: string;
  description?: string;
  action?: ButtonProps;
  size?: 'small' | 'medium' | 'large';
  icon?: IconSvgElement;
}

const EmptyState = ({
  size = 'medium',
  title = 'Sin Contenido',
  description = 'Cuando agregues contenido se verá aquí',
  action,
  icon,
}: Props) => {
  const { palette } = useTheme();
  return (
    <Stack spacing={1} alignItems="center" justifyContent="center" flex={3}>
      <Stack textAlign="center" spacing={3}>
        <Stack alignItems="center">
          {icon && <HugeiconsIcon icon={icon} size={46} strokeWidth={1} color={palette.primary.main} />}
        </Stack>
        <Stack spacing={1}>
          <Typography variant="h3">{title}</Typography>
          <Typography variant="body2" sx={{ marginTop: 0 }}>
            {description}
          </Typography>
        </Stack>
      </Stack>
      {action ? <Button {...action} fullWidth={false} size={size} /> : null}
    </Stack>
  );
};

export default EmptyState;
